export default __webpack_public_path__ + "static/media/Group.36d41b22.png";